import { useFormContext } from "react-hook-form";
import { useLastValidValues } from "../../utils/form/useLastValidValues.esm.js";
import { COMMON_AMOUNT_CONFIG } from "../../utils/zhl-calculator.esm.js";
const FieldConfig = {
  homeValue: {
    name: "homeValue",
    config: {
      ...COMMON_AMOUNT_CONFIG,
      max: {
        value: 1e9,
        message: "Must be $1,000,000,000 at most."
      }
    }
  },
  loanBalance: {
    name: "loanBalance",
    config: {
      ...COMMON_AMOUNT_CONFIG,
      max: {
        value: 8e5,
        message: "Must be $800,000 at most."
      },
      min: {
        value: 1e3,
        message: "Must be at least $1,000."
      }
    }
  }
};
function useLastValidHelocValues() {
  const form = useFormContext();
  return useLastValidValues(form, getHelocValues);
}
function getHelocValues(lastValidFields) {
  const combinedLoneToValueRatio = 0.85;
  const calculations = {
    creditLine: combinedLoneToValueRatio * lastValidFields.homeValue - lastValidFields.loanBalance
  };
  const values = {
    fields: lastValidFields,
    calculations
  };
  return values;
}
export {
  FieldConfig,
  useLastValidHelocValues
};
